/* eslint-disable @nx/enforce-module-boundaries */
'use-client';
import { isMobile } from 'react-device-detect';
import { ProfileLayout } from 'v4/snippets/profile/layout';
import { MyProfilePhotos } from 'v4/snippets/profile/photos';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';

const Profile = () => {
  return (
    <AuthenticatedProviders>
      {/* <ProfileLayout active={isMobile?1:2}> */}
      <ProfileLayout active={2}>
        <MyProfilePhotos />
      </ProfileLayout>
    </AuthenticatedProviders>
  );
};

export default Profile;
